export const STRIPE_API_VERSION = "2025-08-27.basil";

export const STRIPE_SUBSCRIPTION_PLAN_KEYS = {
  monthly: "monthly",
  annual: "annual",
} as const;

export type StripeSubscriptionPlanKey =
  (typeof STRIPE_SUBSCRIPTION_PLAN_KEYS)[keyof typeof STRIPE_SUBSCRIPTION_PLAN_KEYS];

export const STRIPE_FREE_FOR_LIFE_PLAN_KEY = "free_for_life" as const;

export const STRIPE_DEFAULT_SIGNUP_PLAN_KEY = STRIPE_SUBSCRIPTION_PLAN_KEYS.monthly;
export const STRIPE_DEFAULT_TRIAL_DAYS = 14;

// These lookup keys are stable identifiers in Stripe and should not change when rotating prices.
export const STRIPE_PLAN_LOOKUP_KEYS = {
  monthly: "nfp_monthly",
  annual: "nfp_annual",
  founderAnnual: "nfp_annual_founder",
  freeForLife: "nfp_free_for_life",
} as const;

export const APPLE_SUBSCRIPTION_PRODUCT_IDS = {
  monthly: "co.mitchmedia.nfptracker.access.monthly",
  annual: "co.mitchmedia.nfptracker.access.yearly",
} as const;

export type AppleSubscriptionProductId =
  (typeof APPLE_SUBSCRIPTION_PRODUCT_IDS)[keyof typeof APPLE_SUBSCRIPTION_PRODUCT_IDS];

export const APPLE_PRODUCT_IDS_BY_PLAN_KEY: Record<StripeSubscriptionPlanKey, AppleSubscriptionProductId> = {
  monthly: APPLE_SUBSCRIPTION_PRODUCT_IDS.monthly,
  annual: APPLE_SUBSCRIPTION_PRODUCT_IDS.annual,
};

export const APPLE_PLAN_KEY_BY_PRODUCT_ID: Record<AppleSubscriptionProductId, StripeSubscriptionPlanKey> = {
  [APPLE_SUBSCRIPTION_PRODUCT_IDS.monthly]: STRIPE_SUBSCRIPTION_PLAN_KEYS.monthly,
  [APPLE_SUBSCRIPTION_PRODUCT_IDS.annual]: STRIPE_SUBSCRIPTION_PLAN_KEYS.annual,
};

export const APPLE_BILLING_PROVIDER = "apple" as const;
export const STRIPE_BILLING_PROVIDER = "stripe" as const;

export type BillingProvider =
  | typeof APPLE_BILLING_PROVIDER
  | typeof STRIPE_BILLING_PROVIDER;

export const APP_WEB_ORIGIN = "https://app.nfptracker.com";
export const APP_DEEP_LINK_SCHEME = "co.mitchmedia.nfptracker";
export const APP_LOCAL_DEV_ORIGIN = "http://localhost:8080";
export const APP_FALLBACK_ORIGIN = APP_WEB_ORIGIN;
export const APP_TRUSTED_WEB_HOST_SUFFIXES = [
  "nfptracker.com",
  "localhost",
  "127.0.0.1",
] as const;

// Link invites (spouse and instructor) stay valid long enough for the invitee to sign up weeks
// later. Mirrored by the link_invites.expires_at default in migration
// 20260728160000_spouse_invite_expiry_and_accept_reasons.sql.
export const LINK_INVITE_EXPIRY_DAYS = 90;
/** @deprecated Use LINK_INVITE_EXPIRY_DAYS; kept as an alias for existing callers. */
export const SPOUSE_INVITE_EXPIRY_DAYS = LINK_INVITE_EXPIRY_DAYS;

export const SUPPORT_EMAIL = "support@nfptracker.com";
export const SUPPORT_MAILTO_URL = `mailto:${SUPPORT_EMAIL}`;
export const TERMS_OF_USE_URL = "https://nfptracker.com/terms";
export const PRIVACY_POLICY_URL = "https://nfptracker.com/privacy";

export const APP_EMAIL_FROM_ADDRESS = "onboarding@nfptracker.com";
export const APP_EMAIL_FROM_NFP_TRACKER = `NFP Tracker <${APP_EMAIL_FROM_ADDRESS}>`;
export const APP_EMAIL_FROM_FERTILITY_TRACKER = `Fertility Tracker <${APP_EMAIL_FROM_ADDRESS}>`;
